<template>
  <div class="row mt-3">
    <div class="col text-center">
      <span class="link" @click="showOrigin">Источники информации</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "OriginButton",
  methods: {
    showOrigin() {
      this.$root.$emit('showOrigin');
    },
  }
}
</script>

<style lang="scss" scoped>
.link {
  cursor: pointer;
  color: var(--default-text-color);
  font-size: 12px;
}
</style>